export enum NCZIElectronicExaminationRecordType {
	PROFESSIONAL_EXAMINATION = 'ZAZNAM_O_ODBORNOM_VYSETRENI',
	RELEASE_REPORT = 'ZAZNAM_PREPUSTACIA_SPRAVA',
	IMAGING_EXAMINATION = 'ZAZNAM_O_ZOBRAZOVACOM_VYSETRENI',
}
